export default "__VITE_ASSET__89e3b453__"